import { api } from './client';

export async function saveUseCase(childProfileId, useCase) {
  return api.post('/onboarding/use-case', { child_profile_id: childProfileId, use_case: useCase });
}

export async function selectCurriculum(childProfileId, curriculumSlug) {
  return api.post('/onboarding/curriculum-select', { child_profile_id: childProfileId, curriculum_slug: curriculumSlug });
}

export async function completeOnboarding(childProfileId) {
  return api.post('/onboarding/complete', { child_profile_id: childProfileId });
}

export async function finalizeOnboarding(childProfileId, curriculumSlug) {
  let timezone = null;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    timezone = null;
  }
  return api.post('/onboarding/finalize', {
    child_profile_id: childProfileId,
    curriculum_slug: curriculumSlug,
    timezone,
  });
}

export async function getOnboardingResume() {
  return api.get('/onboarding/resume');
}

// Records the onboarding language choice: sets users.app_language AND the
// onboarding_language_chosen_at marker atomically (BP-ONBOARDING-LANGUAGE-STEP-01).
export async function chooseOnboardingLanguage(language) {
  return api.post('/onboarding/language', { language });
}
